/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
const ToastEnum = {
	INFO: 'info',
	SUCCESS: 'success',
	WARNING: 'warning',
	ERROR: 'error'
};
Object.freeze( ToastEnum );
module.exports = ToastEnum;



// WEBPACK FOOTER //
// ./src/js/dialog/schematic/ToastEnum.js